module.exports = __webpack_public_path__ + "static/customerChat.9a082a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/customerChat.svg
// module id = 505
// module chunks = 35783957827783